module.exports = __webpack_public_path__ + "static/media/gallaxy-background-contact.8f36ba3c.jpg";